import type React from 'react'
import { type PlacesType, Tooltip as ReactTooltip } from 'react-tooltip'

type TooltipProps = {
  id: string
  children?: React.ReactNode
  place?: PlacesType
  trigger?: 'hover' | 'click'
  className?: string
}

export const Tooltip = ({
  id,
  children,
  place = 'bottom',
  trigger = 'hover',
  className,
}: TooltipProps) => {
  // Place `data-tooltip-id={id}` on a focusable host. Hover trigger also opens on focus
  // Main difference now is keyboard can open the tooltip too
  const openEvents =
    trigger === 'click'
      ? { click: true }
      : {
          mouseenter: true,
          focus: true,
        }
  const closeEvents =
    trigger === 'click'
      ? { click: true }
      : {
          mouseleave: true,
          blur: true,
        }

  return (
    <ReactTooltip
      id={id}
      place={place}
      openEvents={openEvents}
      closeEvents={closeEvents}
      className={className}
    >
      {children as React.ReactNode}
    </ReactTooltip>
  )
}
